<template>
  <div class="form-horizontal form-material">
    <h3 class="text-center m-b-20">Sign Up</h3>
    <div class="social text-center">
      <div class="button-group">
        <link-button
          :click="() => ssoAuth('facebook')"
          class="waves-effect waves-light btn-rounded btn-facebook"
        >
          <i aria-hidden="true" class="fab fa-facebook-f mr-2"></i>
          Sign up with FACEBOOK
        </link-button>
        <link-button
          :click="() => ssoAuth('google')"
          class="waves-effect waves-light btn-rounded btn-googleplus"
        >
          <i aria-hidden="true" class="fab fa-google-plus-g mr-2"></i>
          Sign up with GOOGLE
        </link-button>
        <div class="line-center text-center my-3">
          <span>or</span>
        </div>
        <link-button
          :click="() => toggleEmailSignUpModal(true)"
          class="waves-effect waves-light btn-rounded btn-secondary"
        >
          Sign up with EMAIL
        </link-button>
        <modal
          :show="openEmailSignUpModal"
          :close="() => toggleEmailSignUpModal(false)"
          title="Sign Up with Email"
        >
          <div class="modal-body">
            <form @submit.prevent="handleEmailSignUp">
              <div class="form-group mb-0 pb-4 d-flex align-items-center text-left">
                <label for="name" class="form-label col-md-4">Name</label>
                <input
                  v-model="signUpForm.name"
                  type="text"
                  id="name"
                  class="form-control custom-input col-md-8"
                  placeholder="Enter your name"
                  required
                />
              </div>
              <div class="form-group mb-0 pb-4 d-flex align-items-center text-left">
                <label for="email" class="form-label col-md-4">Email</label>
                <input
                  v-model="signUpForm.email"
                  type="email"
                  id="email"
                  class="form-control custom-input col-md-8"
                  placeholder="Enter your email"
                  required
                />
              </div>
              <div class="form-group mb-0 pb-4 d-flex align-items-center text-left">
                <label for="password" class="form-label col-md-4">Password</label>
                <input
                  v-model="signUpForm.password"
                  type="password"
                  id="password"
                  class="form-control custom-input col-md-8"
                  placeholder="Enter your password"
                  required
                />
                <small v-if="passwordError" class="text-danger error-small">{{ passwordError }}</small>
              </div>
              <div class="form-group mb-0 pb-4 d-flex align-items-center text-left">
                <label for="confirmPassword" class="form-label col-md-4">Confirm Password</label>
                <input
                  v-model="signUpForm.confirmPassword"
                  type="password"
                  id="confirmPassword"
                  class="form-control custom-input col-md-8"
                  placeholder="Confirm your password"
                  required
                />
              </div>
              <small v-if="confirmPasswordError" class="text-danger error-small">{{ confirmPasswordError }}</small>
              <div class="text-right mt-4">
                <button type="submit" class="btn btn-primary btn-custom">Sign Up</button>
                <button type="button" class="btn btn-secondary ml-2" @click="toggleEmailSignUpModal(false)">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </modal>
      </div>
    </div>
    <div class="form-group">
      <div class="col-sm-12 text-center">
        Already have an account?
        <router-link
          :to="{ name: 'login' }"
          class="text-info m-l-5"
          aria-expanded="false"
        >
          Login
        </router-link>
      </div>
    </div>
    <modal
      :show="openEmailModal"
      :close="() => openEmailWarningModal(false)"
      title="Notice"
    >
      <h3 class="swal2-title" id="swal2-title" style="display: flex;">We don't support sign up with email currently. please use the method above.</h3>

      <div slot="footer">
        <div class="flex-group">
          <button type="button" class="btn btn-secondary flex-item" @click="() => openEmailWarningModal(false)">
            Close
          </button>
        </div>
      </div>

    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LinkButton from '@/components/Misc/LinkButton';
import Modal from "@/components/Misc/Modal";
import AuthService from "@/Services/AuthService";
import { ADD_TOAST_MESSAGE } from "vuex-toast";

export default {
  name: "register",
  components: {
    LinkButton,
    Modal
  },
  props: [ 'stayAfter' ],
  data() {
    return {
      openEmailSignUpModal: false,
      signUpForm: {
        name: '',
        email: '',
        password: '',
        confirmPassword: ''
      },
      passwordError: '',
      confirmPasswordError: '',
    };
  },
  computed: {
    ...mapGetters({
      openEmailModal: 'auth/openEmailModal',
    })
  },
  methods: {
    ...mapActions({
      ssoLogin: 'auth/ssoLogin',
      openEmailWarningModal: 'auth/openEmailWarningModal',
    }),
    async ssoAuth(provider) {
      const auth = this.$auth;
      await this.ssoLogin({ auth, provider });
      if (!this.stayAfter) {
        this.$router.push({ name: 'index' });
      }
    },
    toggleEmailSignUpModal(status) {
      this.openEmailSignUpModal = status;
    },
    /**
     * @description Regex to check a password with at least 8 characters, including uppercase letters, lowercase letters, numbers and special characters
     */
    validatePassword(password) {
      const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
      return passwordPattern.test(password);
    },
    handleEmailSignUp() {
      this.passwordError = "";
      this.confirmPasswordError = "";

      if (!this.validatePassword(this.signUpForm.password)) {
        this.passwordError = "Password must be at least 8 characters long and include an uppercase letter, lowercase letter, numbers and special character.";
        return;
      }

      if (this.signUpForm.password !== this.signUpForm.confirmPassword) {
        this.confirmPasswordError = "Passwords do not match.";
        return;
      }

      this.submitSignUp();
    },
    async submitSignUp() {
      try {
        const response = await AuthService.register(this.signUpForm);
        response.success
          ? this.$store.dispatch(
              ADD_TOAST_MESSAGE,
              {
                text: "Registration successful!",
                type: "success",
              },
              {
                root: true,
              },
            )
          : this.$store.dispatch(
              ADD_TOAST_MESSAGE,
              {
                text: "Registration failed. Please try again.",
                type: "danger",
              },
              {
                root: true,
              },
            );
        this.$router.push({ name: "login" });
      } catch (error) {
        this.$store.dispatch(
          ADD_TOAST_MESSAGE,
          {
            text: "Registration failed. Please try again.",
            type: "danger",
          },
          {
            root: true,
          },
        );
      }
    }
  }
};
</script>
<style scoped>
.line-center {
  border-bottom: 1px solid #e0e1e2;
  line-height:0.1em;
  margin:10px 0 20px;
}

.line-center span {
  background:#fff;
  padding:0 10px;
}

.error-small {
  padding-left: 10px;
  position: absolute;
  bottom: 0;
}
</style>